import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { profile } from "../../data/profile";

const DEFAULT_DESCRIPTION = `${profile.name} is a ${profile.role} building React Native mobile apps with Node.js, Express, MongoDB, MySQL and AWS. Based in ${profile.location}.`;

const Seo = ({ title, description = DEFAULT_DESCRIPTION }) => {
  const fullTitle = title
    ? `${title} · ${profile.name}`
    : `${profile.name} · ${profile.role}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Seo;
